import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SettingsService } from 'src/app/core/setttings/settings.service';
import { MaskSchedule } from '../models/mask-schedule';

@Injectable({
  providedIn: 'root',
})
export class PlanificationMaskService {
  private planificationMaskBaseUrl: string;

  public readonly maskScheduleChanged: Subject<{ assetId: number | null; nextValidityEndDate: Date | null; maskSchedule: MaskSchedule | null }> = new Subject();

  constructor(private httpClient: HttpClient, private settingsService: SettingsService, private translateService: TranslateService) {
    this.planificationMaskBaseUrl = `${this.settingsService.settings.API_URL}/maskschedule`;
  }

  public updateMaskSchedule(assetId: number | null, nextValidityEndDate: Date | null, maskSchedule: MaskSchedule | null): void {
    this.maskScheduleChanged.next({ assetId, nextValidityEndDate, maskSchedule });
  }

  /** Get a mask schedule */
  public getByMaskId(maskId: number): Observable<MaskSchedule> {
    return this.httpClient.get<MaskSchedule>(`${this.planificationMaskBaseUrl}/${maskId}`).pipe(
      map((x) => {
        x.startDate = moment.utc(x.startDate).toDate();
        if (x.endDate !== null) x.endDate = moment.utc(x.endDate).toDate();
        if (x.repetitionEndDate !== null) x.repetitionEndDate = moment.utc(x.repetitionEndDate).toDate();
        return x;
      }),
      catchError((err) => {
        err.message = this.translateService.instant('mask.schedule.error.get_by_mask_id', {
          id: maskId,
        });
        return throwError(err);
      })
    );
  }

  /**
   * Create or update a mask schedule
   */
  public send(maskSchedule: MaskSchedule): Observable<MaskSchedule> {
    if (maskSchedule.id === 0) {
      return this.post(maskSchedule);
    }

    return this.put(maskSchedule);
  }

  /** Post a mask schedule */
  private post(maskSchedule: MaskSchedule): Observable<MaskSchedule> {
    return this.httpClient.post<MaskSchedule>(`${this.planificationMaskBaseUrl}`, maskSchedule, { observe: 'body' }).pipe(
      catchError((err) => {
        err.message = this.translateService.instant('mask.schedule.error.post');
        return throwError(err);
      })
    );
  }

  /** Put a mask schedule */
  private put(maskSchedule: MaskSchedule): Observable<MaskSchedule> {
    return this.httpClient.put<MaskSchedule>(`${this.planificationMaskBaseUrl}/${maskSchedule.id}`, maskSchedule, { observe: 'body' }).pipe(
      catchError((err) => {
        err.message = this.translateService.instant('mask.schedule.error.put');
        return throwError(err);
      })
    );
  }
}
